import { createAction, props } from '@ngrx/store';
import { PaymentMandateRequest } from '../models/payment-mandate.model';

export const saveAddCreditCards = createAction('[SaveCard] Save CardDetails', props<{ saveCard: PaymentMandateRequest }>());
